import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { injectIntl, defineMessages } from 'react-intl';
import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';

import { Message, List } from 'semantic-ui-react';
import { ModalTemplate, Button, Loading, ReduxFormHiddenInput } from 'components';

import * as common from 'libs/commonFunc';

import styles from '../../../style/modal.css';
import classNames from 'classnames/bind';
const cx = classNames.bind(styles);

class ModalExamDelete extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    // 국제화 처리
    const { formatMessage } = this.props.intl;
    const { visible, isClicked, onExamDelete, onToggleModal, selectedExam } = this.props;

    if (!selectedExam) {
      return null;
    }
    return (
      <ModalTemplate
        closeOnEscape={false}
        closeOnDimmerClick={false}
        className={cx('modal-examDelete-area', 'common-content')}
        visible={visible}
        onToggleModal={onToggleModal}
        header={defineMessages(formatMessage({ id: 'ModalExamDelete_1', defaultMessage: '훈련 삭제' }))}
        buttons={
          <div className={cx('inline-block')}>
            <Button
              buttonColor="#bbbbbb"
              onClick={() => {
                onToggleModal('');
              }}>
              {defineMessages(formatMessage({ id: 'ModalExamDelete_3', defaultMessage: '취 소' }))}
            </Button>
            <Button className={cx('gray-button')} disabled={isClicked} loading={isClicked} onClick={onExamDelete}>
              {defineMessages(formatMessage({ id: 'ModalExamDelete_2', defaultMessage: '삭 제' }))}
            </Button>
          </div>
        }>
        <div className={cx('message-header')}>
          {defineMessages(
            formatMessage({
              id: 'ModalExamDelete_4',
              defaultMessage: '삭제한 훈련은 복구할 수 없습니다. 다음 훈련을 삭제합니까?'
            })
          )}
        </div>
        <Message className={cx('template-detail-box')}>
          <Loading active={isClicked} size="small" content="Waiting..." />
          <ReduxFormHiddenInput name="examNo" />
          <ReduxFormHiddenInput name="examName" />
          {/* <Message.Header>
            {defineMessages(
              formatMessage({
                id: 'ModalExamDelete_4',
                defaultMessage: '삭제한 훈련은 복구할 수 없습니다. 다음 훈련을 삭제합니까?'
              })
            )}
          </Message.Header> */}
          <div className={cx('template-detail')}>
            <List bulleted className={cx('template-detail-list')}>
              <List.Item className={cx('template-detail-item')}>
                <div className={cx('template-detail-item-title')}>
                  {defineMessages(formatMessage({ id: 'ModalExamDelete_5', defaultMessage: '훈련 번호' }))}
                </div>
                {selectedExam.get('examNo')}
              </List.Item>
              <List.Item className={cx('template-detail-item')}>
                <div className={cx('template-detail-item-title')}>
                  {defineMessages(formatMessage({ id: 'ModalExamDelete_6', defaultMessage: '훈련명' }))}
                </div>
                {selectedExam.get('examName')}
              </List.Item>
              <List.Item className={cx('template-detail-item')}>
                <div className={cx('template-detail-item-title')}>
                  {defineMessages(formatMessage({ id: 'ModalExamDelete_7', defaultMessage: '훈련 기간' }))}
                </div>
                {common.timeFormatFromUTCEpoch(selectedExam.get('examStartEpoch'), 3)}
                &nbsp;~&nbsp;
                {common.timeFormatFromUTCEpoch(selectedExam.get('examEndEpoch'), 3)}
              </List.Item>
              <List.Item className={cx('template-detail-item')}>
                <div className={cx('template-detail-item-title')}>
                  {defineMessages(formatMessage({ id: 'ModalExamDelete_8', defaultMessage: '등록일시' }))}
                </div>
                {common.timeFormatFromUTCEpoch(selectedExam.get('regEpoch'))}
              </List.Item>
            </List>
          </div>
        </Message>
      </ModalTemplate>
    );
  }
}
ModalExamDelete.propTypes = {
  visible: PropTypes.bool,
  onDeleteExam: PropTypes.func,
  onToggleModal: PropTypes.func
};

const mapStateToProps = (state, props) => {
  return {
    initialValues: {
      examNo: props.selectedExam.get('examNo'),
      examName: props.selectedExam.get('examName')
    }
  };
};

export default connect(mapStateToProps)(
  reduxForm({ form: 'formExamDelete', enableReinitialize: true })(injectIntl(ModalExamDelete))
);



// WEBPACK FOOTER //
// ./src/script/components/modal/ModalExamDelete.js